import React, { useState } from 'react';

// Multi-select of curated options PLUS free-text entry for anything not listed.
// value = string[], onChange(arr). options = string[] (curated suggestions).
// Selecting from the dropdown adds it; typing a custom value + Enter/Add adds it.
export default function OptionTagPicker({ value, onChange, options = [], accent = '#2dd4bf', placeholder = '+ Add…', customPlaceholder = 'Other — type & Enter' }) {
  const [custom, setCustom] = useState('');
  const arr = Array.isArray(value) ? value : [];
  const add = (v) => { const t = (v || '').trim(); if (t && !arr.includes(t)) onChange([...arr, t]); };
  const remove = (v) => onChange(arr.filter(x => x !== v));
  const addCustom = () => { add(custom); setCustom(''); };

  const inp = {
    background: 'var(--ni-panel)', border: '1px solid var(--ni-border-soft)', color: 'var(--ni-text)',
    borderRadius: 6, padding: '8px 12px', fontSize: 13, boxSizing: 'border-box',
  };
  const avail = options.filter(o => !arr.includes(o));

  return (
    <div>
      <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
        <select value="" onChange={e => { add(e.target.value); e.target.value = ''; }} style={{ ...inp, flex: '1 1 200px' }}>
          <option value="">{placeholder}</option>
          {avail.map(o => <option key={o} value={o}>{o}</option>)}
        </select>
        <input value={custom} onChange={e => setCustom(e.target.value)}
          onKeyDown={e => { if (e.key === 'Enter') { e.preventDefault(); addCustom(); } }}
          placeholder={customPlaceholder} style={{ ...inp, flex: '1 1 160px' }} />
        <button type="button" onClick={addCustom} disabled={!custom.trim()}
          style={{ background: accent + '22', color: accent, border: `1px solid ${accent}44`, borderRadius: 6,
            padding: '0 14px', fontSize: 12, fontWeight: 700, cursor: custom.trim() ? 'pointer' : 'not-allowed' }}>Add</button>
      </div>
      {arr.length > 0 && (
        <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', marginTop: 8 }}>
          {arr.map(v => (
            <span key={v} style={{ display: 'inline-flex', alignItems: 'center', gap: 6, padding: '3px 10px', borderRadius: 20,
              fontSize: 12, fontWeight: 700, background: accent + '22', color: accent }}>
              {v}
              <button type="button" onClick={() => remove(v)}
                style={{ background: 'none', border: 'none', color: 'inherit', cursor: 'pointer', padding: 0, fontSize: 13, lineHeight: 1 }}>×</button>
            </span>
          ))}
        </div>
      )}
    </div>
  );
}
